import { apiClient } from '@/lib/api';
import type {
  AuditEntityType,
  AuditTrailResponse,
  AuditTrailSearchQuery,
} from '@skewb-works/contracts';

const BASE = '/works-lite/audit-trail';

interface PaginationParams {
  limit?: number;
  skip?: number;
}

export async function getAuditTrailForEntity(
  entityType: AuditEntityType,
  entityId: number,
  params: PaginationParams = {},
): Promise<AuditTrailResponse> {
  const { limit = 50, skip = 0 } = params;
  return apiClient.get<AuditTrailResponse>(
    `${BASE}/entity/${entityType}/${entityId}?limit=${limit}&skip=${skip}`,
  );
}

export async function searchAuditTrail(
  filters: Partial<AuditTrailSearchQuery> = {},
): Promise<AuditTrailResponse> {
  const { limit = 50, skip = 0, ...rest } = filters;
  const params = new URLSearchParams();
  params.set('limit', String(limit));
  params.set('skip', String(skip));

  for (const [key, value] of Object.entries(rest)) {
    if (value !== undefined && value !== null) {
      params.set(key, String(value));
    }
  }

  return apiClient.get<AuditTrailResponse>(`${BASE}/search?${params.toString()}`);
}
